import { createActionGroup } from '@ngrx/store';

export const SocieteComposantFamilleActions = createActionGroup({
  source: 'Societe Composant Famille',
  events: {}
});
